<template>
  <v-dialog v-if="showLogoutModal" value="true" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">Logout</span>
      </v-card-title>
      <v-card-text>
        You have been logged out of Assist. Would you also like to logout of Magellan SSO Okta?
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="blue darken-1"
          text
          @click.native="logoutSSO"
        >
          Logout of SSO
        </v-btn>
      </v-card-actions>
      <v-card-text>
        <p>If you don't logout of SSO then you can sign back into Assist by simply loading it.</p>
        <p>If you do logout of SSO it will also log you out of any other applications that are using Magellan SSO Okta.</p>
        <p>Otherwise, simply close this tab or window.</p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'logout-modal',
  computed: {
    ...mapState('adminSettings', ['showLogoutModal'])
  },
  methods: {
    logoutSSO() {
      window.location = this.showLogoutModal.logoutUrl + '?id_token_hint=' + this.showLogoutModal.idToken + (this.showLogoutModal.logoutHome ? '&post_logout_redirect_uri=' + this.showLogoutModal.logoutHome : '')
    }
  }
}
</script>
